import { parse, stringify } from "qs";

export default {
  parse: (query) => parse(query, { ignoreQueryPrefix: true, arrayLimit: 9999 }),
  stringify: (query) => stringify(query),
};

export { parse, stringify };
